import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import PassengerType from '../../../../../../components/ui/PassengerType';
import { getDisplayPassengerId } from './HistoryDetails.utils';

const HistoryActionPassengerId = ({ passenger }) => {
  if (!passenger?.id) {
    return '-';
  }

  return (
    <FormattedMessage
      id="history.paxId"
      values={{
        passengerId: getDisplayPassengerId(passenger.id),
        passengerType: passenger.type ? <PassengerType type={passenger.type} disabilityType={passenger.disabilityType} /> : '-'
      }}
    />
  );
};

HistoryActionPassengerId.propTypes = {
  passenger: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    disabilityType: PropTypes.string
  })
};

export default HistoryActionPassengerId;
